export default function precision() {
    if (!this.exchange) return;

    return {
        take: Math.pow(10, +this.exchange.currency.take.precision),
        give: Math.pow(10, +this.exchange.currency.give.precision)
    };
}
